import "./SideNav.scss";
// import { ReactComponent as Dashboard } from "../../../.././assets/svg/dashboard.svg";
// import { ReactComponent as UserManagement } from "../../../.././assets/svg/user_management.svg";
// import { ReactComponent as HospitalIntegration } from "../../../.././assets/svg/hospital_integration.svg";
import { ReactComponent as Clinic } from "../../../../assets/svg/Clinic.svg";
import { ReactComponent as Logs } from "../../../../assets/svg/equalizer.svg";
import Navigation from "../Navigation/Navigation";
import { routePaths } from "../../../../constants/routePaths";
export interface sideNavProps {
  setIsSideNavOpen: any;
  isSideNavOpen: boolean;
}
function SideNav(props: sideNavProps) {
  let routes = [
    {
      text: "Clinic Management",
      icon: Clinic,
      link: routePaths.clinicManagement,
    },
    {
      text: "Communication Logs",
      icon: Logs,
      link: routePaths.communicationLogs,
    },
    // {
    //   text: "User Management",
    //   icon: Info,
    //   link: routePaths.userManagement,
    // },
  ];
  const navigation = routes.map((item, index) => (
    <li className="mb-4" key={item.text}>
      <Navigation {...props} navItem={item} />
    </li>
  ));
  return (
    <>
      <div className="side-nav-wrapper">
        <ul className="list-unstyled mb-0">{navigation}</ul>
      </div>
      <div className="d-flex flex-column side-nav-footer-wrapper align-items-center"></div>
    </>
  );
}

export default SideNav;
